import React, { useState } from "react";
import "./Videocard.css";
import sample_video from "../../assets/loader2.mp4";

export default function Videocard({ name, videoRef, type, muteEnabled }) {
  // console.log(videoRef);

  return (
    <div className=" w-[calc(60%)] flex flex-row items-center justify-center">
      {/* <div className='videocard_name'>{name}</div> */}
      <video
        loop
        src={sample_video}
        ref={videoRef}
        autoPlay
        muted={muteEnabled}
        id={type}
      ></video>
    </div>
  );
}
